import React from "react";
import SvgIcon, { SvgIconProps } from "@mui/material/SvgIcon";
import {ReactComponent as FediverseSvg} from './imgs/svgicons/fediverse.svg';
import {ReactComponent as ThreadsSvg} from './imgs/svgicons/threads.svg';
import {ReactComponent as MastodonSvg} from './imgs/svgicons/mastodon.svg';
import {ReactComponent as MisskeySvg} from './imgs/svgicons/misskey.svg';
import {ReactComponent as TumblrSvg} from './imgs/svgicons/tumblr.svg';
import {ReactComponent as FacebookSvg} from './imgs/svgicons/facebook.svg';
import {ReactComponent as TwitterSvg} from './imgs/svgicons/twitter.svg';
import {ReactComponent as InstagramSvg} from './imgs/svgicons/instagram.svg';

type Props = React.HTMLProps<SvgIconProps>;

export const FediverseIcon: React.FC<Props> = (props) => {
  return (
    <SvgIcon stroke="auto">
      <FediverseSvg width="100%" height="100%"/>
    </SvgIcon>
  );
};

export const ThreadsIcon: React.FC<Props> = (props) => {
	return (
	  <SvgIcon>
		<ThreadsSvg width="100%" height="100%"/>
	  </SvgIcon>
	);
};

export const MastodonIcon: React.FC<Props> = (props) => {
	return (
	  <SvgIcon>
		<MastodonSvg width="100%" height="100%"/>
	  </SvgIcon>
	);
};

export const MisskeyIcon: React.FC<Props> = (props) => {
	return (
	  <SvgIcon>
		<MisskeySvg width="100%" height="100%"/>
	  </SvgIcon>
	);
};

export const TumblrIcon: React.FC<Props> = (props) => {
	return (
	  <SvgIcon>
		<TumblrSvg width="100%" height="100%"/>
	  </SvgIcon>
	);
};

export const FacebookIcon: React.FC<Props> = (props) => {
	return (
	  <SvgIcon>
		<FacebookSvg width="100%" height="100%"/>
	  </SvgIcon>
	);
};

export const TwitterIcon: React.FC<Props> = (props) => {
	return (
	  <SvgIcon>
		<TwitterSvg width="100%" height="100%"/>
	  </SvgIcon>
	);
};

export const InstagramIcon: React.FC<Props> = (props) => {
	return (
	  <SvgIcon>
		<InstagramSvg width="100%" height="100%"/>
	  </SvgIcon>
	);
};